import { isEmpty } from 'lodash';
import { AddressField } from '@shared/data/entity/fields/AddressField';

/** An address as one line of text, with its city: "123 Main St, Springfield, IL". */
export function getAddressText(field: AddressField): string {
  const { title, subtitle } = field.address;
  return [title, subtitle].filter(line => !isEmpty(line)).join(', ');
}
